import InputLabel from "./InputLabel";
import rebuildTooltipsHOC from "../../../enhancers/rebuildTooltipsHOC";
var InputLabelWithToolTipReload = rebuildTooltipsHOC(InputLabel);
export default InputLabelWithToolTipReload;